export default "__VITE_ASSET__503a4bd1__"